export default "__VITE_ASSET__b1cdce21__"